import mod from "-!../../../node_modules/babel-loader/lib/index.js?cacheDirectory!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./alreadyAssignedDetail.vue?vue&type=script&lang=js&"; export default mod; export * from "-!../../../node_modules/babel-loader/lib/index.js?cacheDirectory!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./alreadyAssignedDetail.vue?vue&type=script&lang=js&"


//////////////////
// WEBPACK FOOTER
// ./src/views/logisticsDelivery/alreadyAssignedDetail.vue?vue&type=script&lang=js&
// module id = null
// module chunks = 